module.exports = __webpack_public_path__ + "media/images/bread-menu-icon-da849c98eee6d273717306de3bf20d28.png";